
import { createContext, useEffect, useRef } from 'react';
import Shepherd from 'shepherd.js';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'app/contexts/auth/context';

import { hasTourBeenCompleted, markTourCompleted, resetTour } from './persistence';

import { getStepsForModule } from './steps';

export const TourContext = createContext(); 

const MODULE = import.meta.env.VITE_REACT_APP_MODULE;


export function TourProvider({ children }) {

  const { t } = useTranslation();

  // Récupérer les informations de l'utilisateur connecté pour gérer la persistance de l'état de la visite guidée.
  const { user } = useAuthContext();

  // Ref pour stocker l'instance du tour afin de pouvoir y accéder dans les méthodes de contexte (start, stop, reset) 
  // et dans les événements de complétion/annulation.
  const tourRef = useRef();

  
  const buildTour = () => {

    const tour = new Shepherd.Tour({
      useModalOverlay: true,

      defaultStepOptions: { 
        cancelIcon: {
          enabled: true, 
        },

        scrollTo: { 
          behavior: 'smooth', 
          block: 'center',
        },

        classes: 'app-tour', 
      },
    });

    // Récupérer les étapes spécifiques au module courant et les ajouter au tour
    const steps = getStepsForModule(MODULE, t);


    // Ajouter chaque étape au tour
    steps.forEach((step) => {
      if (step.attachTo?.element) {

      }

      tour.addStep(step);
    });

    // Configurer les événements de complétion et d'annulation pour marquer la visite comme complétée
    tour.on('complete', () => {
      markTourCompleted(user.id);
    });

    
    tour.on('cancel', () => {
      markTourCompleted(user.id);
    });

    // Stocker l'instance du tour dans le ref pour pouvoir y accéder dans les méthodes de contexte (start, stop, reset) 
    // et dans les événements de complétion/annulation.
    tourRef.current = tour;

    return tour;
  };


  useEffect(() => {
    if (!user?.id) return;


    if (hasTourBeenCompleted(user.id)) return;

    const timer = setTimeout(() => {
      buildTour().start();
    }, 1500);

    return () => {
      clearTimeout(timer);
      tourRef.current?.cancel();
    }
  }, [user]);

  return (

    // Fournir les méthodes de contexte pour démarrer, arrêter ou réinitialiser la visite guidée.
    <TourContext.Provider
      value={{
        start: () => buildTour().start(),
        stop: () => tourRef.current?.cancel(),
        reset: () => resetTour(user?.id),
      }}
    >
      {children}
    </TourContext.Provider>
  );
}